import { useTourStore } from '../store/tourStore.js'

/**
 * TourButton — small "Tour" button people can click any time to replay
 * the guided walkthrough. Lives in the top nav so it's always visible
 * and never in the way.
 */
export default function TourButton() {
  const start = useTourStore((s) => s.start)
  return (
    <button
      type="button"
      onClick={start}
      title="Take a guided tour of the dashboard"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '5px 10px',
        border: '1px solid var(--border)',
        borderRadius: 99,
        fontSize: 11,
        fontWeight: 600,
        background: '#fff',
        color: 'var(--muted)',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
      }}
    >
      🧭 Tour
    </button>
  )
}
